// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalBugReport_header__2sxrw","header__name":"ModalBugReport_header__name__1FwLs","header__close":"ModalBugReport_header__close__xP53x"};